// extracted by mini-css-extract-plugin
export default {"header":"PeriodFormHeader_header__XWTvh"};